import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet, useNavigate } from "react-router-dom";
import Subheader from "./Subheader";
import { socket } from "../socket";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const orgName = sessionStorage.getItem("organizationName");
    const orgId = sessionStorage.getItem(`${orgName}_organizationId`);

      const handleFeaturesUpdated = (data) => {
      if (String(data.organizationId) === String(orgId)) {
        Object.keys(sessionStorage).forEach((key) =>
          sessionStorage.removeItem(key)
        );
        toast.info(
          "Your organization's features have been updated. Please log in again.",
          { containerId: "layout-toast", autoClose: 4000 }
        );
        setTimeout(() => navigate("/login"), 1500);
      }
    };

    socket.on("featuresUpdated", handleFeaturesUpdated);

    return () => {
      socket.off("featuresUpdated", handleFeaturesUpdated);
    };
  }, [navigate]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <div className="flex h-screen">
      <ToastContainer containerId="layout-toast" position="top-right" autoClose={4000} />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="flex flex-col flex-grow overflow-hidden">
        <Header toggleSidebar={toggleSidebar} />
        {/* <Subheader /> */}
        <main className="flex-grow overflow-auto p-4">
          <Outlet />
        </main>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default Layout;